import { render, staticRenderFns } from "./table-common.vue?vue&type=template&id=756883ca"
import script from "./table-common.vue?vue&type=script&lang=js"
export * from "./table-common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports